<template>
  <div v-frag>
    <CardIeaAppMain colorCard="#A7BA38" title="">
      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
        <v-btn
          class="mx-2"
          fab
          dark
          small
          color="success"
          @click="$router.push({ name: 'Home' })"
        >
          <v-icon dark>
            mdi-keyboard-backspace
          </v-icon>
        </v-btn>
        <br /><br />
        <div class="text-title primary-text">{{ title }}</div>
        <v-row align="center">
          <v-col cols="12">
            <div class="subtitle">Indique la/las cuota/s que abonó; y/o detalle su consulta de pagos:</div>
            <v-textarea
              v-model="titulo"
              class="custom-textarea"
              outlined
              hide-details
              required
            ></v-textarea>
          </v-col>
          <v-col cols="12">
            <div class="subtitle">Por favor, agregue cualquier Imagen, PDF, etc, de su comprobante de pago:</div>
            <v-file-input
              show-size
              v-model="files"
              :items="files"
              multiple
              counter
              accept="image/*"
              class="custom-file-input-2"
            >
              <template v-slot:selection="{ text }">
                <v-chip
                  small
                  label
                  close
                  @click:close="remove(index)"
                  color="primary"
                >
                  {{ text }}
                </v-chip>
              </template>
            </v-file-input>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="12" md="6">
            <v-btn
              color="success"
              elevation="7"
              large
              v-on:click="examen = true"
              @click="addInforme()"
            >
              Crear informe de pago
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </CardIeaAppMain>
  </div>
</template>
<script>

import CardIeaAppMain from "../../components/CardIeaAppMain";

export default {
  name: "InformarPago",
  components: {
    CardIeaAppMain,
  },

  data: () => ({
    title:"Informar pago",
    titulo: '',
    files:[],
  }),

  methods: {
    remove (index) {
      this.files.splice(index, 1)
    },

    async addInforme() {
      if(this.titulo.trim()  == "" ){
        alert('Porfavor, indique la cuota que paga')
        return;
      }
      
      if(this.files.length == 0){
        alert('Porfavor, agregue comprobante de pago')
        return;
      }

      var formData = new FormData();
      formData.append('titulo',this.titulo);
      formData.append('cantidadImagen',this.files.length);

      console.log(this.$refs)
      let i = 0;
      for (let file of this.files) {
          formData.append(`imagen_${i}`, file, file.name);
          i++;
      }
      console.log(formData);
      
      let url = "consulta-acreditacion/store";
      await this.$API
        .post({
          url: url,
          data: formData
        }).then(() => {
          this.titulo = "";
          this.files = [];
        });
    }
  }
};
</script>
<style scoped>
.subtitle {
  font-size: 1.2rem; /* Tamaño predeterminado */
  font-weight: 500;
  margin-bottom: 8px;
  color: white; /* Cambiar color según tu diseño */
}

/* Responsive ajustes para subtítulos */
@media (max-width: 600px) {
  .subtitle {
    font-size: 16px; /* Tamaño del subtítulo en pantallas pequeñas */
  }
}

.custom-textarea {
  background-color: white !important;
  border: none;
  border-radius: 8px; /* Bordes redondeados */
  color: #000;
}

.custom-textarea .v-input__control {
  padding: 10px !important;
  font-size: 1rem; /* Ajuste general para el texto */
  border-radius: 8px; /* Asegura que el área de control también sea redondeada */
}

/* Asegura que no haya transición de texto */
.custom-textarea::placeholder {
  color: transparent; /* Elimina cualquier placeholder */
}

/* Responsive ajustes para textareas */
@media (max-width: 600px) {
  .custom-textarea .v-input__control {
    font-size: 0.9rem; /* Ajusta tamaño del texto en pantallas pequeñas */
  }
}

.custom-file-input {
  background-color: white !important;
  border: none;
  border-radius: 8px; /* Bordes redondeados para inputs de archivos */
}

.custom-file-input-2 {
  background-color: transparent !important;
  border: none;
  border-radius: 8px; /* Bordes redondeados para inputs de archivos */
}

/* Cambiar color del ícono de adjuntar archivos a blanco */
::v-deep .custom-file-input-2 .v-icon__svg {
  color: white !important; /* Fuerza el color blanco */
}

::v-deep .theme--light.v-counter {
    color: white;
}
/* Título responsivo */
.text-title {
  font-size: 2rem; /* Tamaño predeterminado */
  font-weight: 600;
  margin-bottom: 8px;
  color: white; /* Cambiar color según tu diseño */
}

@media (max-width: 600px) {
  .text-title {
    font-size: 24px; /* Tamaño del título en pantallas pequeñas */
  }
}
</style>


